import { useMutation } from '@tanstack/react-query';

import type { DelteEmployeeWageArgs } from '../../../Domain/Employees/Services/EmployeeService';
import { employeeService } from '../../../Domain/Employees/Services/EmployeeService';

const mutationFn = (data: DelteEmployeeWageArgs) => {
  return employeeService.deleteEmployeeWage(data);
};

export const useEmployeeDeleteWageMutation = () => {
  return useMutation<unknown, unknown, DelteEmployeeWageArgs>(mutationFn);
};
